<template>
  <pt-coupon-detail class="pt-coupon-detail__withData"  :couponDetail="couponDetail" :loading="loading"></pt-coupon-detail>
</template>

<script>
import PtCouponDetail from './index'
export default {
  name: 'pt-coupon-detail__withData',
  components: {
    'pt-coupon-detail': PtCouponDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      couponDetail: {},
      loading: false
    }
  },
  methods: {
    getCouponDetail () {
      this.loading = true
      this.$store.dispatch('couponDetail', this.id).then(res => {
        this.couponDetail = res
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取优惠劵详情失败')
      })
    }
  },
  created () {
    this.getCouponDetail()
  }
}
</script>
